import React, {useState} from 'react'

const AddTodoForm = ({addNewTodo}) => {

    const [addTodo, SetAddTodo] = useState('')

    const handleTodo = (e) =>{
        e.preventDefault()
        addNewTodo(addTodo) // je passe a AddNewTodo qui est une valeur importé de son parent, la valeur de AddTodo
        SetAddTodo('')
    }

    // addNewTodo(addTodo)

    return (
        
            <form className='mt-4' onSubmit={handleTodo}>
                <div className='card card-body'>
                    <div className="form-group">
                        <label> ajouter Todo</label>
                        <input className='form-control' value={addTodo} type='text' onChange={(e)=> SetAddTodo(e.target.value) }/>
                        <input className='btn btn-success mt-4' type='submit' />
                    </div>
                </div>
            </form>
        
    )
}

export default AddTodoForm

